import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import App from "./App.tsx";
import { ProviderProfile } from "./views/ProviderProfile/ProviderProfile.tsx";
import { NotFound } from "./views/NotFound.tsx";
import theme from "./theme";
import "./index.css";

import * as Sentry from "@sentry/react";
import { ErrorBoundary } from "@sentry/react";
import ErrorFallback from "./components/ErrorFallback";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [],
  environment: import.meta.env.VITE_ENV, // 'local', 'test', 'prod'
});

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2026-01-30",
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <ErrorBoundary fallback={ErrorFallback}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<App />} />
              <Route path="/providers/:uuid" element={<ProviderProfile />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </ErrorBoundary>
    </PostHogProvider>
  </StrictMode>
);
